import { Component, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'question',
    templateUrl: 'question.component.html'
})
export class PreviewQuestionComponent {
    @Input('slide') slide;
    @Input('index') i;
    @Input('length') length;

    @ViewChild('progress') progress;

    constructor() {}
    ngAfterViewInit() {
        this.progress.nativeElement.setAttribute('style', 'width:' + this.getProgress(this.i) + '%');
    }
    getProgress(i) {
        let progress = i;
        if( i > 0 ) {
            progress = (progress / this.length) * 100;
            progress = Math.round(progress);
        }
        return progress;
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/preview/parts/question.component.ts